module.exports = __webpack_public_path__ + "img/Group 704.65df281a.png";